module.exports = __webpack_public_path__ + "static/media/bg1.f8c2f9ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/bg1.jpg
// module id = 1204
// module chunks = 0